// © Microsoft Corporation. All rights reserved.
import { WebStorage } from "./WebStorage";
import { canUseDOM } from "@msnews/isomorphic-util";
/* eslint-disable msnews-experiences-rules/no-direct-api-usage */
/**
 * Local storage class for persistent storage
 */
export class LocalStorage extends WebStorage {
    constructor() {
        let storage = null;
        if (canUseDOM()) {
            try {
                storage = localStorage;
            }
            catch (ex) {
                // Getting local storage failed. Can happen in Chrome when user has disabled cookies.
            }
        }
        super(storage);
    }
}
/**
 * Set the local storage instance. Useful when setting up mock storage instance.
 * @param _storage The local storage instance to change to.
 */
export function setLocalStorage(_storage) {
    safeLocalStorage = _storage;
}
/**
 * Get the local storage instance. This should be used in place of window.localStorage
 * as the browser API would throw exception on browsers with cookies disabled.
 * @return The local storage instance.
 */
export function getLocalStorage() {
    return safeLocalStorage;
}
let safeLocalStorage = new LocalStorage();
//# sourceMappingURL=LocalStorage.js.map